import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';

import DefaultBanner from '../../../components/DefaultBanner';

import {
  Grid,
  Row,
  Col,
} from '../../../incubation/components/ResponsiveGridLayout';

import Link from '../../../components/Link';

import s from './Shadower.scss';

class Shadower extends React.Component {
  render() {
    return (
      <>
        <DefaultBanner
          breadcrumb={
            <ul
              className="breadcrumb"
              itemScope
              itemType="https://schema.org/BreadcrumbList"
            >
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/"
                >
                  <span itemProp="name">Home</span>
                </Link>
                <meta content="0" itemProp="position" />
              </li>
              <li
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <Link
                  itemProp="item"
                  itemType="https://schema.org/Thing"
                  to="/portfolio"
                >
                  <span itemProp="name">Portfolio</span>
                  <meta content="1" itemProp="position" />
                </Link>
              </li>
              <li>Shadower</li>
            </ul>
          }
          header="Shadower"
          link="https://shadower.app"
          subHeader="Shadower is a platform for people to gain real life experience in professional fields."
        />
        <section className={s.shadower}>
          <div className={s.about}>
            <div className={s.content}>
              <h3>About Shadower</h3>
              <p>
                Shadower is a platform where experts in a given field share
                their experience with individuals that would like to gain
                industry explerience or explore career options.
              </p>
              <p>
                Shadower provides great value to experts by allowing them to
                choose their price. An expert can decide how long they would
                like to offer the session as well as how much they would like to
                charge.
              </p>
              <p>
                Shadowers gain hands on experience in a wide range of
                professions. This allows people the opportunity to try out
                careers before they commit to a job for years at a time.
              </p>
            </div>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/shadower-mockup-iphone3v2.png"
              />
            </div>
          </div>

          <div className={s.challenge}>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/shadower-mockup-iphone2.png"
              />
            </div>
            <div className={s.content}>
              <h3>Challenge</h3>
              <p>
                We were tasked with designing and developing the Shadower
                platform from the ground up. We had to develop calendars,
                booking modals, payment portals, expert profiles, search tools,
                and more.
              </p>
            </div>
          </div>

          <div className={s.about}>
            <div className={s.content}>
              <h3>Solution</h3>
              <p>
                We created all the features described above plus a few other
                features because of a small amount of scope creep. The scope
                creep we did encounter was manageable because we spent a
                significant amount of time defining the scope in the beginning
                and we gave ourselves a full year to complete a beta version.
              </p>
            </div>
            <div className={s.mobilePreview}>
              <img
                alt="Concept Drawn"
                src="/images/uncompressed/shadower-mockup-iphone4.png"
              />
            </div>
          </div>

          <Grid>
            <Row>
              <Col md={12}>
                <div className={s.laptopPreview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/shadower-mockup-macbook1.png"
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className={s.mobilePreview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/shadower-mockup-iphone1.png"
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className={s.mobilePreview}>
                  <img
                    alt="Concept Drawn"
                    src="/images/uncompressed/shadower-mockup-iphone5.png"
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className={s.linkToWebsiteContainer}>
                  <a href="https://shadower.app">Visit Website</a>
                </div>
              </Col>
              <Col md={12}>
                <div className={s.review}>
                  <img
                    alt="Jason Pacini"
                    src="/images/uncompressed/jason-poster.jpg"
                  />
                  <blockquote>
                    I have been working with Flux Teck for a couple months now
                    to build a web-based application and it has been a very
                    smooth experience. Jonathan and Dan are very knowledgeable
                    and professional.
                    <br />
                    <br />
                    <span>- Jason Pacini | Founder, Shadower</span>
                  </blockquote>
                </div>
              </Col>
            </Row>
          </Grid>
        </section>
      </>
    );
  }
}

export default withStyles(s)(Shadower);
